<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import * as userSubscriptionFormSchema from '../../../forms/userSubscriptionFormSchema';
import moment from 'moment';
import Swal from "sweetalert2";
import { initFirebaseDataBackend } from '../../../helpers/firebase/dataUtils';
import { getFirebaseDataBackend } from '../../../helpers/firebase/dataUtils';
import { getRemoteConfig, getValue, fetchAndActivate } from "firebase/remote-config";

// import { getAuth } from 'firebase/auth';

export default {
  page: {
    title: "User Subcription Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,

  },
  props: ["id","pageTitle"],
  data() {
    return {
      title: "Add New User Subcription",
      model: null,
      schema: null,
      isSaving: false,
      formOptions: {
        validateAfterChanged: true,
        validateAfterLoad: false,
      },
      subscriptionData: null,
      mySubscriptionUrl: ""
    };
  },
  methods: {
    initialModelState() {
      this.model = { 
            subscription: '',
            user: '',
            price: 0,
            type: 'gift',
            entry_remark: '',
            custom_message: '',
      };
    },
    async submitUserDetails() {
      try{
         // Get user info
         const user_id = this.model.user.id;
        const userData = await getFirebaseDataBackend().getDocData("users", this.model.user.id);

        // Get selected subscription
        const selectedSubscriptionRecord = this.subscriptionData.filter(row => row.id === this.model.subscription.id);
        const newExpiryDate = (userData.subscription_expiry_date && userData.subscription_expiry_date > 0) ? userData.subscription_expiry_date : moment().unix();
        
        // Remove unused model data
        delete(this.model.subscription);
        delete(this.model.user);
        
        const userSubscriptionData = {
          subscription_id: selectedSubscriptionRecord[0].id,
          user_email: userData.email,
          user_mobile_no: userData.mobile_no,
          user_first_name: userData.first_name,
          user_last_name: userData.last_name,
          user_id: user_id,
          subscription_name: selectedSubscriptionRecord[0].name,
          price: (this.model.price > 0) ? this.model.price : selectedSubscriptionRecord[0].price,
          period: selectedSubscriptionRecord[0].period_month,
          expiry_date: moment.unix(newExpiryDate)
                  .add(selectedSubscriptionRecord[0].period_month, "M").unix(),
          status: 'active',
        }

        await getFirebaseDataBackend()
        .addData("user_subscription",  {...this.model, ...userSubscriptionData})
        .then(() => {
          const mailData = {
            to: userSubscriptionData.user_email,
            mail_category: "admin_free_subscription",
            template: {
              name: "admin_free_course_subscription",
              data: {
                item_type: "subscription",
                item_name: userSubscriptionData.subscription_name,
                custom_message: this.model.custom_message ?? "There is a special reward for you",
                first_name: userSubscriptionData.user_first_name ?? "",
                last_name: userSubscriptionData.user_last_name ?? "",
                check_item_url: this.mySubscriptionUrl,
              },
            },
          };

          getFirebaseDataBackend()
          .addData("mail",  mailData)
          .then(() => {
            // Add a new document in collection "cities"
            Swal.fire("Created!", "User Subscription Created.", "success");
            this.$router.push({
              name: "user-course-list",
            })
          })
          .catch(error => {
            console.log(error);
            Swal.fire("Failed!", "User subscription created but failed to trigger email.", "error");
          });
        })
        .catch(error => {
          console.log(error);
          Swal.fire("Failed!", "User Subscription failed to create.", "error");
        }); 
      } catch (error) {
        console.log(error)
        Swal.fire("Failed!", "User Subscription failed to create.", "error");
      }
    },
  },
  created() {
    initFirebaseDataBackend();
  },
  mounted() {
    const remoteConfig = getRemoteConfig();
    // remoteConfig.settings.minimumFetchIntervalMillis = process.env.VUE_APP_REMOTE_CONFIG_REFRESH_TIME;

    fetchAndActivate(remoteConfig)
    .then(() => {
      const val = getValue(remoteConfig, "my_subscription_url");
      this.mySubscriptionUrl = val._value;
    })
    .catch((err) => {
       console.log(err);
       this.mySubscriptionUrl = "https://superbullklse.com/subscription-history";
       getFirebaseDataBackend()
          .addData("error_log", {source: "admin_remote_subscription_url_error", error_message: err})
          .catch((err) => { console.log(err); });
    });

    this.initialModelState();
    const queryParam = [{
      param_type: "where",
      field_name: "status",
      operator: "==",
      value: "active"
    }];
    const returnSubscriptionList = [];
    const returnUserList = [];
    getFirebaseDataBackend().getListData("subscriptions", queryParam)
        .then(data => {
          for(const row of data){
            returnSubscriptionList.push({ id: row.id, name: row.name});
          }
          this.subscriptionData = data;
          this.initialModelState();
          const queryParam = [{
            param_type: "where",
            field_name: "status",
            operator: "==",
            value: "active"
          }];
          getFirebaseDataBackend().getListData("users", queryParam)
              .then(data => {
                for(const row of data){
                  returnUserList.push({ id: row.id, name: `${row.first_name} ${row.last_name} - ${row.email}`});
                }
                this.schema = userSubscriptionFormSchema.getSchema(returnSubscriptionList, returnUserList);
              });
        })
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">User Subscription Detail</h4>
            <div class="card ">
              <form action="" @submit.prevent="submitUserDetails">
                  <vue-form-generator tag="div" :schema="schema" :options="formOptions" :model="model" />
                  <div class="d-flex justify-content-end mt-3 pr-4">
                      <button type="submit" class="btn btn-primary btn-lg">
                          {{ isSaving ? 'Saving...' : 'Submit'}}
                      </button>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>